import { geocoderAPIUrl } from './constants';

export default function makeGeocoderUrl(query) {
    return `${geocoderAPIUrl}?q=${query}`;
}
